import React from 'react';

/*
 * Per chi e` una pagina dell'app: utenti normali (di solito la promozione di Premium) oppure utenti Premium
 * (quello che vedono dopo aver acquistato). Lo decide l'app e il backend lo manda in `audience`
 * ('free' | 'premium' | 'all'; sportid-docs, «modifiche 9 ottobre», sez. 2).
 */
const ETICHETTE = { premium: 'Utenti Premium', normali: 'Utenti normali', tutti: 'Tutti gli utenti' };

const DA_AUDIENCE = { premium: 'premium', free: 'normali', all: 'tutti' };

export const destinatari = (slug, audience) => DA_AUDIENCE[audience] || 'tutti';
export const etichettaDestinatari = (slug, audience) => ETICHETTE[destinatari(slug, audience)];

export const ChipDestinatari = ({ slug, audience }) => (
    <span className={`sid-chip-utenti is-${destinatari(slug, audience)}`}>{etichettaDestinatari(slug, audience)}</span>
);
